"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoAnimation = void 0;

var _styledComponents = require("styled-components");

var _InOutAnimation = require("./InOutAnimation");

var noAnimationBase = (0, _styledComponents.css)([""]);
var noAnimationEnter = (0, _styledComponents.css)([""]);
var noAnimationExit = (0, _styledComponents.css)(["visibility:hidden;"]);
var NoAnimation = (0, _InOutAnimation.createInOutAnimation)({
  baseStyles: noAnimationBase,
  enterStyles: noAnimationEnter,
  exitStyles: noAnimationExit
});
exports.NoAnimation = NoAnimation;